import { Component } from '@angular/core';
import { ProximityUser } from '@models';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface ProfileEditRequestDialogData {
  user: ProximityUser;
}

@Component({
  template: `
    <div class="flex flex-col gap-4">
      <!-- Current profile info -->
      <div class="qb-detail-card p-4">
        <div class="text-sm font-semibold mb-2" style="color: var(--p-text-muted-color);">Current Profile</div>
        <div class="flex flex-col gap-1">
          <div><span class="font-medium">Name:</span> {{ data.user.fullName }}</div>
          <div><span class="font-medium">Email:</span> {{ data.user.email || '—' }}</div>
          <div><span class="font-medium">Phone:</span> {{ data.user.telephoneNumber || '—' }}</div>
        </div>
      </div>

      <!-- Request message -->
      <div>
        <label class="block text-sm font-medium mb-1" style="color: var(--p-text-color);">
          What changes would you like made to your profile?
        </label>
        <textarea pInputTextarea [(ngModel)]="message" [rows]="5" class="w-full"
          placeholder="e.g., Please update my last name to Smith and my phone to (555) 123-4567"></textarea>
      </div>

      <!-- Buttons -->
      <div class="flex justify-end gap-2 pt-2">
        <button pButton (click)="cancel()" type="button" icon="pi pi-times" label="Cancel"
          class="p-button-outlined"></button>
        <button pButton (click)="submit()" type="button" icon="pi pi-send" label="Send Request"
          [disabled]="!message.trim()" class="p-button-raised p-button-primary"></button>
      </div>
    </div>
  `,
  standalone: false,
})
export class ProfileEditRequestDialogComponent {
  data!: ProfileEditRequestDialogData;
  message = '';

  constructor(
    dialogConfig: DynamicDialogConfig<ProfileEditRequestDialogData>,
    private ref: DynamicDialogRef,
  ) {
    this.data = dialogConfig.data as any;
  }

  cancel() {
    this.ref.close(null);
  }

  submit() {
    this.ref.close(this.message.trim());
  }
}
